var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common-filter-tool" }, [
    _c(
      "div",
      { staticClass: "filters" },
      [
        !_vm.isShowingOnlyTemplate() && _vm.showClearAll && !_vm.hideFilters
          ? _c(
              "div",
              { staticClass: "clear-preview", on: { click: _vm.clearAll } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("clear")]),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("chatWindow.clearAll")) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.clone, function (filter, key) {
          return !_vm.isShowingOnlyTemplate() &&
            (!_vm.hideFilters || _vm.requiredFilters.includes(filter.name))
            ? _c(
                "CommonFilterItem",
                _vm._b(
                  {
                    key: filter.type,
                    attrs: {
                      "on-removed": function () {
                        return _vm.onFilterRemoved(filter.name)
                      },
                      "default-open": _vm.lastAddedFilter === filter.type,
                      "on-finished": function () {
                        return (_vm.lastAddedFilter = null)
                      },
                      autoRemoveWhenCancel: _vm.lastAddedFilter === filter.type,
                      "label-formatter": _vm.labelFormatter,
                      removeable:
                        filter.clearable === true ||
                        filter.clearable === undefined,
                    },
                    model: {
                      value: _vm.clone[key],
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, key, $$v)
                      },
                      expression: "clone[key]",
                    },
                  },
                  "CommonFilterItem",
                  filter,
                  false
                )
              )
            : _vm._e()
        }),
        _vm._v(" "),
        !_vm.isShowingOnlyTemplate() &&
        _vm.getAvailableFilters().length &&
        _vm.showAddButton
          ? _c(
              "a-popover",
              {
                attrs: {
                  visible: _vm.filterMenuVisible,
                  overlayClassName: "filterMenu no-padding",
                  placement: "bottom",
                  trigger: "click",
                },
                on: {
                  visibleChange: function (isVisible) {
                    return (_vm.filterMenuVisible = isVisible)
                  },
                },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c(
                    "div",
                    { staticClass: "custom-list-wrapper filter-list-bg" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-list" },
                        _vm._l(_vm.getAvailableFilters(), function (filter) {
                          return _c(
                            "div",
                            {
                              staticClass: "custom-list-item",
                              on: {
                                click: function () {
                                  return _vm.addFilter(filter.name)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(
                                  _vm._s(filter.materialIcon || "filter_alt")
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(filter.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-button" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" add "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-button-text" }, [
                    _vm._v(_vm._s(_vm.$t("chatbotv2.addFilter"))),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showSaveButton
          ? _c(
              "div",
              { staticClass: "add-button star", on: { click: _vm.saveFilter } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" star "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-button-text" }, [
                  _vm._v(_vm._s(_vm.$t("message.saveFilter"))),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowingOnlyTemplate() && _vm.filterTemplates.length
          ? _c(
              "a-popover",
              {
                key: "filterTemplates",
                attrs: {
                  visible: _vm.templateMenuVisible,
                  overlayClassName: "filterMenu no-padding",
                  placement: "bottom",
                  trigger: "click",
                },
                on: {
                  visibleChange: function (isVisible) {
                    return (_vm.templateMenuVisible = isVisible)
                  },
                },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c(
                    "div",
                    { staticClass: "custom-list-wrapper filter-list-bg" },
                    [
                      _c(
                        "div",
                        { staticClass: "custom-list" },
                        _vm._l(_vm.filterTemplates, function (filter) {
                          return _c(
                            "div",
                            {
                              staticClass: "custom-list-item",
                              on: {
                                click: function () {
                                  return _vm.applyFilterTemplate(filter.name)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(
                                  _vm._s(filter.materialIcon || "filter_alt")
                                ),
                              ]),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(filter.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "add-button" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" filter_list "),
                  ]),
                  _vm._v(" "),
                  _vm.selectedFilterTemplate
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: _vm.selectedFilterTemplate },
                              expression: "{ content: selectedFilterTemplate }",
                            },
                          ],
                          staticClass: "add-button-text",
                        },
                        [
                          !_vm.minimize
                            ? [_vm._v(_vm._s(_vm.$t("calendar.list")) + ":")]
                            : _vm._e(),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.selectedFilterTemplate.length > 15
                                  ? _vm.selectedFilterTemplate.substring(
                                      0,
                                      15
                                    ) + "..."
                                  : _vm.selectedFilterTemplate
                              ) +
                              "\n                "
                          ),
                        ],
                        2
                      )
                    : _c("div", { staticClass: "add-button-text" }, [
                        _vm._v(_vm._s(_vm.$t("chatWindow.selectFilter"))),
                      ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(" arrow_drop_down "),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._t("extra"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }